export default {
  complex: {
    avg_price_sqm: 'Preț mediu pe m²',
    min_price: 'Preț minim',
    max_price: 'Preț maxim',
    expected_delivery: 'Predare estimată',
    construction_start: 'Începerea construcției',
    construction_end: 'Finalizarea construcției',
    sales_start: 'Începerea vânzărilor',
    distance_to_sea: 'Distanța până la mare',
    distance_to_center: 'Distanța până la centru',
    distance_to_airport: 'Distanța până la aeroport',
    roi: 'Prognoză ROI',
    amenities: 'Facilități',
    yes: 'Da',
    no: 'Nu',
    infrastructure: 'Infrastructură',
    nearby: 'În apropiere',
    gallery: 'Galerie',
    video: 'Video',

    // deja adăugate
    total: 'Total unități',
    available: 'Disponibile',
    buildings: 'Clădiri',
    floors_short: 'et.',
    cover_alt: 'Coperta complexului rezidențial',

    // 🔹 chei noi pentru componentă
    details: {
      developer: 'Dezvoltator',
      location: 'Locație',
      country: 'Țară',
      region: 'Regiune',
      city: 'Oraș',
      district: 'Cartier',
      characteristics: 'Caracteristici',
      class: 'Clasă',
      buildings_count: 'Număr de clădiri',
      construction_start: 'Începerea construcției',
      sales_start: 'Începerea vânzărilor',
      construction_end: 'Finalizarea construcției',
      delivery: 'Predare',
      investments_prices: 'Investiții și prețuri',
      total_value_available: 'Valoarea totală a apartamentelor disponibile',
      price_from: 'Preț de la',
      price_to: 'Preț până la',
      price_per_sqm: 'Preț pe m²',
      roi: 'Prognoză ROI',
      amenities: 'Facilități',
      infrastructure: 'Infrastructură',
      description: 'Descriere',
      distances: 'Distanțe',
      to_sea: 'Până la mare',
      to_center: 'Până la centru',
      to_airport: 'Până la aeroport'
    },

    // Exemple pentru facilități
    amenities: {
      pool: 'Piscină',
      parking: 'Parcare',
      gym: 'Sală de sport',
      security: 'Securitate'
      // se pot adăuga toate din backend
    },

    // Exemple pentru infrastructură
    infrastructure: {
      school: 'Școală',
      kindergarten: 'Grădiniță',
      supermarket: 'Supermarket',
      hospital: 'Spital'
      // se pot adăuga toate din backend
    },

    properties_in_complex: 'Apartamente în acest complex',
    description: 'Descriere'
  },
  residential_class: {
    complex: {
      class: 'Clasă'
    }
  },
  loading: 'Se încarcă...'
}
